<template>
    <div class="container-base" v-once>
        <div class="pages page-static">
            <div class="page-static-inner">
                <h2>ヤギオファー利用規約</h2>
                <p>株式会社Yagish（以下「弊社」といいます）が運営する後記のヤギオファー（以下「本サービス」といいます）のご利用に際しては、以下の利用規約（以下「本規約」といいます）をお読みいただいた上で、本規約に同意いただき、本規約を内容とする本サービス利用契約（以下「本契約」といいます）を締結いただく必要があります。なお、ヤギオファーの個別のサービス名称が追加・変更される場合も、本規約が適用されます。
                </p>

                <h2>第1条（規約の適用）</h2>
                <p>本規約は、本サービスのご利用にあたっての条件及びご利用に関する条件を定めており、弊社と後記の利用者及び仮登録者との間の本サービスの利用に関わる一切の関係に適用されます。ただし、本サービスに関連する弊社の個別サービス等に関し本規約の内容と異なる内容を別途定めた場合は、その規定が優先適用されます。
                </p>

                <h2>第2条（サービスの定義）</h2>
                <ol>
                    <li>「本サービス」とは、弊社が運営するWebサイト（弊社Webサイトのドメイン又は内容が変更された場合は、当該変更後のWebサイトを含みます）及びスマートフォン向けアプリ等で提供する「ヤギオファー」において弊社が提供する就職活動支援サービスの総称（サービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます）をいいます。
                    </li>
                    <li>「利用者」とは、第３条第１項に定める要件を満たし、本条第６項の利用者登録をした者をいいます。</li>
                    <li>「利用希望者」とは、本サービスを利用するため、利用者となることを希望する者をいいます。</li>
                    <li>「利用企業」とは、弊社の審査を経て、弊社が提供する本サービスを通じて自社の人材採用のために利用者と接触することを承認した企業をいいます。</li>
                    <li>「利用者登録」とは、利用希望者が、弊社から登録アドレス宛に送られるメールの記載に従い本人確認手続き（以下「認証手続き」といいます）を行い、かつ、認証手続き後に、自らの意思で弊社所定の登録情報を本サービスに登録することをいいます。
                    </li>
                    <li>「オファー」とは、利用企業が採用基準を満たす可能性があるものと判断した利用者に対し、本サービスを用いて説明会や面接等の案内を送付することをいいます。</li>
                    <li>「マイページ」とは、プロフィール登録やオファーの状況の閲覧をするために弊社が設置する利用者及び仮登録者（以下「利用者等」といいます）ごとのウェブページをいいます。</li>
                    <li>「ID等」とは、利用者等が本サービスの利用に際して用いるID及びパスワードであって、当該利用者等のマイページにログインするために必要なものをいいます。</li>
                    <li>「利用者情報」とは、登録情報、その他本サービス利用に関し弊社（弊社サイト内におけるアクセス履歴を含む）及び利用企業が取得した利用者に関する情報をいいます。</li>
                    <li>前各号のほか、本規約においては、別途個人情報保護法に定義のある用語は、その例によります。</li>
                </ol>

                <h2>第3条（利用者登録及び利用者の責任）</h2>
                <ol>
                    <li>登録希望者は、本規約を遵守することに同意し、かつ、当社の定める一定の情報（以下、「登録情報」といいます。）を当社の定める方法で当社に提供することにより、本サービスの会員登録を申請するものとします。
                    </li>
                    <li>前項の申請は、登録希望者自身が行うものとし、真実、正確かつ最新の情報を当社に提供するものとします。</li>
                    <li>当社は、本条第1項に基づき会員登録を申請した登録希望者が、以下の各号のいずれかの事由に該当する場合は、当該登録希望者の会員登録を拒否することができるものとします。
                        <ul>
                            <li>本規約に違反するおそれ又は明確な違反があると当社が判断した場合</li>
                            <li>当社に提供された登録情報の全部又は一部につき虚偽、重要な誤記、記載漏れがある場合</li>
                            <li>過去に本サービスの会員登録取消処分を受けたことがある場合</li>
                            <li>その他当社が会員登録を適当でないと判断した場合</li>
                        </ul>
                    </li>
                    <li>当該利用者のマイページは利用企業に対し自動的に公開され、オファーを受けることができる状態となることに、あらかじめ同意します。ただし、利用者はマイページをいつでも非公開に変更し、又は、マイページの内容を変更・修正することができます。
                    </li>
                    <li>利用者等は、責任をもって本サービスを利用し、登録情報が常に自己の最新かつ正確な情報であるように変更・追加・削除するとともに、自らの責任において登録情報を管理します。</li>
                    <li>利用者は、オファーを承諾した企業から直接メッセージ、電話又はメール等による連絡を受け取る場合があることをあらかじめ同意します。なお、利用企業はオファー送信等の採用活動を第三者に委託することがあります。
                    </li>
                    <li>利用者等は、弊社が別途定める「プライバシーポリシー」及び「個人情報取得に係る明示事項」に従い利用者等の個人情報を取り扱うことに同意します。</li>
                </ol>

                <h2>第4条（本サービスの利用）</h2>
                <ol>
                    <li>弊社は、利用者に対し、本規約に従い本サービスを日本国内において非独占的に利用することを許諾します。</li>
                    <li>利用者は本サービスを無料で利用することができます。</li>
                    <li>本サービスの利用に要する機器、通信費用等は、すべて利用者等の負担とします。弊社は利用者等の使用する機器等が本サービスに適合するものであることを保証するものではありません。</li>
                    <li>利用者等は、本サービスに関するお問い合わせへの対応など、利用者等における本サービス利用の利便性向上等のため、弊社が本サービスのご利用状況（本サービス内における利用企業とのメッセージを含む）を確認する場合があることに同意します。
                    </li>
                    <li>弊社は、本規約又は本サービスの内容、利用条件の変更、休止又は廃止等を自由に行うことができるものとします。これらの変更等を行う場合は、マイページ又は電子メール等によって事前に掲載・通知をし、当該変更等の内容は、弊社がマイページに掲載後、利用者等が本サービスの利用を終了しない場合、１４日後に効力を生じるものとします。
                    </li>
                </ol>

                <h2>第5条（本サービス利用の終了）</h2>
                <p>当社は、当社の自由裁量により会員への事前の通知及び承諾を得ることなく、本サービスの一部または全部を中断、中止、停止、廃止、変更することができます。なお、本サービスの中断、中止、停止、廃止、変更により会員に生じた損害について、当社は一切の責任を負いません。
                </p>

                <h2>第6条（ID等の管理等）</h2>
                <ol>
                    <li>利用者等は、ID等を自己の責任において適切に管理し、登録情報の内容が最新となるよう利用者等で適宜修正する義務を負います。</li>
                    <li>利用者等は、いかなる場合にも、ID等を第三者に利用させ、又は貸与、譲渡、名義変更、売買等をしてはなりません。</li>
                    <li>弊社は、IDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのID等を登録している利用者等による利用とみなし、これに基づき弊社又は第三者に生じた損害はすべて、そのID等を保有する利用者等が負担するものとします。
                    </li>
                    <li>利用者等は、ID等が不正に利用されていることを知った場合には、直ちにその旨を弊社に連絡するものとします。</li>
                    <li>ID等以外の登録情報に変更があったときは、利用者等は速やかにマイページを用いて変更手続きを行うものとし、登録情報に不正確な点があることが判明した場合も同様とします。</li>
                    <li>登録アドレスに変更があったときは、変更手続き完了前に弊社が変更前の登録アドレス宛に送付したメールは、有効に利用者等に送付されたものとみなします。</li>
                    <li>利用者等は、ID等の盗難・紛失・不正使用・第三者による無断使用等によって生じた損害に関する一切の責任を負い、弊社はこれに関して一切の責任を負いません。</li>
                </ol>

                <h2>第7条（個人情報）</h2>
                <ol>
                    <li>利用者情報の利用目的は、本規約に別途定めている事項のほか、本サービスの提供及びそれに関連する事項とします。</li>
                    <li>利用者は、自己の利用者情報が利用企業に提供されることについて、本規約をもって同意します。</li>
                    <li>弊社は、利用者情報を個人情報ではなく統計情報又は匿名加工情報として利用者の同意なしに利用・提供することがあります。</li>
                </ol>

                <h2>第8条（禁止事項）</h2>
                <ol>
                    <li>利用者等は、本サービスの利用にあたり、次の各号の行為をしてはなりません。
                        <ol>
                            <li>（1）本規約に違反する行為。</li>
                            <li>（2）虚偽又は第三者の情報など不適切な情報を登録する行為。</li>
                            <li>（3）弊社又は第三者の権利を侵害するおそれのある行為。</li>
                            <li>（4）他の利用者等のID等を取得・利用し、又は第三者にID等を開示する行為。</li>
                            <li>（5）本サービスの運営を妨げる行為、弊社の信用若しくは名誉を毀損する行為又はそのおそれのある行為。</li>
                            <li>（6）本サービス上での宣伝、広告、勧誘又は営業行為その他本サービスの利用目的に反する行為。</li>
                            <li>（7）日本国又はご利用の際に利用者が所在する国・地域の法令、社会規範又は公序良俗に反する行為。</li>
                            <li>（8）重複して仮登録又は利用者登録する行為。</li>
                            <li>（9）利用者等の自己PRのための目的以外でURLをマイページに掲載する行為（ただし、弊社が別途掲載を許可している場合は除く）。</li>
                            <li>（10）自己のメールアドレス、電話番号又はSNSアカウント等を、マイページに掲載する行為。</li>
                            <li>（11）オファーを承諾し選考が継続している場合に、当該オファー承諾を取り消す行為。</li>
                            <li>（12）他の利用者等の個人情報及びその他本サービスに登録されている情報を当該利用者等に無断で収集したり蓄積したりする行為。</li>
                            <li>（13）その他弊社が不適切と判断する行為。</li>
                        </ol>
                    </li>
                    <li>弊社は、利用者等の同意を得ることなく、マイページにおける前項の禁止事項の遵守状況を確認することがあります。</li>
                </ol>

                <h2>第9条（登録抹消・再登録の拒否等）</h2>
                <ol>
                    <li>弊社は、利用者等が本規約に違反し、又は本サービスの利用が適当でないと判断した場合、何らの通知することなく、直ちに本サービスの利用を停止し、利用者情報の削除、利用者登録及び仮登録の抹消又は再登録を拒否できます。
                    </li>
                    <li>弊社は、利用者等が本サービスに重複登録していることを発見した場合、重複する登録情報及びマイページのうち、いずれかを、利用者等に通知することなく削除できます。</li>
                    <li>弊社は、面接その他イベントの参加状況等に関する弊社からの問い合わせに対して利用者等が30日間以上応答しない場合、何らの通知を要せず、本サービスの利用を停止できます。なお、弊社からのこれらの問い合わせは、メール、電話又はマイページに掲載すること等によって行います。
                    </li>
                    <li>弊社は、前各項の規定により利用者等に生じた不利益及び損害について一切の責任を負いません。</li>
                </ol>

                <h2>第10条（本サービスの停止）</h2>
                <ol>
                    <li>弊社は次の各号に定める事項が生じた場合は、自らの判断により利用者等に対する本サービスの全部又は一部を中断することができます。
                        <ul>
                            <li>（1）天災地変、戦争、暴動、公権力による命令処分等不可抗力が発生し又は発生しうると予見される場合。</li>
                            <li>（2）弊社の管理する設備若しくはシステムの保守を定期的に又は緊急に行う場合。</li>
                            <li>（3）弊社の管理する設備若しくはシステムの障害その他やむを得ない事由が生じた場合。</li>
                        </ul>
                    </li>
                    <li>弊社は、前項の規定により本サービスを中断する場合、弊社が適当と判断する方法で事前に利用者等及び利用企業にその旨を通知又は弊社のホームページ上に掲示します。ただし、かかる本サービスの中断が緊急に必要な場合、又はやむを得ない事情により通知できない場合には、この限りではありません。
                    </li>
                    <li>弊社は、本条第１項により本サービスを中断したことによって利用者等に生じた損害を賠償する責任を負わないものとし、利用者等はこれをあらかじめ承諾するものとします。</li>
                </ol>

                <h2>第11条（退会）</h2>
                <ol>
                    <li>利用者は、利用者の自由意思で本サービスから退会できるものとします。</li>
                    <li>退会を希望する利用者は、退会手続きに従って、本サービスから退会するものとします。</li>
                    <li>前項の手続き上で不備があった場合、退会手続きが完了しない場合があります。</li>
                    <li>退会された利用者の利用者情報は利用者情報データベース（ヤギッシュ履歴書作成サービスおよびヤギオファー）から削除します。</li>
                </ol>

                <h2>第12条（本サービスの仕様変更）</h2>
                <p>弊社は、利用者等及び利用企業の利便性の改善やバグの修正等を目的として、利用者等に対して事前に通知することなく、本サービスのシステム仕様等を変更することがあります。</p>

                <h2>第13条（保証の否認及び免責）</h2>
                <ol>
                    <li>利用者等は、本サービスが利用者の特定の目的に適合すること、期待する機能・正確性・確実性・有用性を有すること及びシステム上の不具合が生じないことに関して弊社は何ら保証するものではないことをあらかじめ了承の上、自己の責任において利用します。
                    </li>
                    <li>利用者等は、本サービスにおいて提供される情報（企業の採用情報、メッセージ送受信機能により提供された情報等を含みます）に関して弊社は何ら保証するものではないことをあらかじめ了承の上、自己の責任において利用します。
                    </li>
                    <li>弊社は、弊社の故意又は重過失によらない場合、利用者等に対する責任は免責されるものとします。弊社の故意又は重過失に起因する場合でも、弊社は通常生じうる損害の範囲内で損害賠償責任を負うものとします。
                    </li>
                    <li>弊社は、本サービスの利用に関連して利用者等と他の利用者等又は第三者との間において生じた取引、連絡、紛争等について、弊社の故意又は重過失に起因する場合を除き、一切の責任を負いません。</li>
                </ol>

                <h2>第14条（反社会的勢力との取引排除）</h2>
                <ol>
                    <li>弊社及び利用者等は、それぞれ相手方に対し、次の各号の事項を確約するものとします。
                        <ul>
                            <li>（1）自らが、暴力団、暴力団員、暴力団員でなくなったときから５年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団その他これらに準ずる者（以下総称して「反社会的勢力」といいます）ではないこと。
                            </li>
                            <li>（2）反社会的勢力に自己の名義を利用させ、本契約を締結するものでないこと。</li>
                            <li>（3）自ら又は第三者を利用して、本契約に関して次の行為をしないこと。
                                <ul>
                                    <li>（ａ）相手方に対する脅迫的な言動又は暴力を用いる行為。</li>
                                    <li>（ｂ）偽計又は威力を用いて相手方の業務を妨害し、又は信用を毀損する行為。</li>
                                    <li>（ｃ）法的な責任を超えた不当な要求行為。</li>
                                    <li>（ｄ）その他前各号に準ずる行為。</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>当事者の一方が次の各号の一に該当した場合には、その相手方は、何らの通知、催告を要せず、直ちに本契約を解除することができます。
                        <ul>
                            <li>（1）前項（1）の確約に反する表明をしたことが判明した場合。</li>
                            <li>（2）前項（2）の確約に反し契約をしたことが判明した場合。</li>
                            <li>（3）前項（3）の確約に反した行為をした場合。</li>
                        </ul>
                    </li>
                    <li>前項の規定により本契約が解除された場合には、解除された者は、その相手方に対し、相手方の被った損害を賠償するものとします。</li>
                    <li>本条第２項の規定により本契約が解除された場合には、解除された者は、解除により生じる損害について、その相手方に対し一切の請求を行わないものとします。</li>
                </ol>

                <h2>第15条（知的財産保護）</h2>
                <ol>
                    <li>弊社及び利用者等は、本サービスを通じて相手方から提供を受けた著作物その他の知的財産について、本サービスの利用のためにのみ使用を許諾されるものとし、相手方の事前の書面による承諾を得ることなく他の目的で使用、複製、転写、又は頒布することはできないものとします。
                    </li>
                    <li>弊社及び利用者等は、本サービスの利用が終了した場合、前項の知的財産について、速やかに相手方の指示に従い、相手方に返還、安全な方法による廃棄処分又は相手方からデータファイル形式により相手方の知的財産を受領している場合は、当該データを速やかに消去するものとします。
                    </li>
                </ol>

                <h2>第16条（権利義務譲渡の禁止）</h2>
                <p>弊社の事前の書面による承諾を得ることなく、利用者等が本規約に基づく一切の権利義務を第三者に譲渡若しくは貸与し又は担保に供することはできません。</p>

                <h2>第17条（損害賠償）</h2>
                <p>弊社及び利用者等は、本規約に違反して相手方に損害を与えた場合、当該損害が生じた原因が自己の故意又は重過失によるものである場合は、相手方に対し、その損害を賠償する責任を負います。</p>

                <h2>第18条（統計情報、属性情報、利用記録の閲覧、集計及び利用）</h2>
                <p>当社は、会員登録・抹消の前後を問わず、本サービスを利用して会員が登録した会員の登録情報等、本サービスの利用履歴およびこれらを特定の個人を識別または識別しないで解析した後、特定の個人を識別できないように加工、集計および分析した統計データ、属性情報等を作成し、当該解析結果、利用履歴、統計データ、属性情報等につき何らの制限なく利用（求人企業または転職エージェントへ閲覧させること、求人企業または転職エージェントへの提案、市場の調査、新サービスの開発を含みますが、これらに限られません。）することができるものとし、会員はこれをあらかじめ承諾します。
                </p>

                <h2>第19条（秘密保持及び会員情報の保護）</h2>
                <p>当社は、会員情報をこの規約で定める場合のほか、別途定めるセキュリティポリシーに基づき、適切に取扱うものとします。但し、次の各号に定める事項については、会員は当社による会員情報の利用及び提供にあらかじめ同意します。
                </p>
                <ol>
                    <li>本サービスを提供するため</li>
                    <li>本サービスに付随するサービス提供のため</li>
                    <li>メールマガジン、メール広告の送付のため</li>
                    <li>アンケートや市場調査のため</li>
                </ol>

                <h2>第20条（準拠法、裁判管轄）</h2>
                <p>本規約の準拠法は日本法とします。また、本サービスまたは本規約に関連して当社と会員の間で生じた紛争については訴額に応じて東京簡易裁判所又は東京地方裁判所を第一審の専属的合意管轄裁判所とする裁判により解決するものとします。
                </p>

                <h2>第21条（協議事項）</h2>
                <p>本規約に定めていない事項については、信義誠実の原則に従い、協議解決するものとします。</p>

                <!--<p class="text-left">個人情報保護に関するお問合せ窓口<br>
                  150-0021<br>
                  東京都渋谷区恵比寿西二丁目3番12号<br>
                  株式会社Yagish
              </p>-->
                <p class="text-right">2023年3月14日制定</p>
                <div class="back-button"><a href="/kr/resume/" class="router-link-active">메인으로</a></div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
export default {
    data: function () {
        return {}
    },
    computed: {},
    methods: {},
    watch: {},
    mounted: function () { }
}
</script>
